import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'
import styled from 'styled-components'

export const RecentlyUsedImageWrapper = styled.div`
  width: 169px;
  height: 96px;
  border-radius: ${RADII.item};
  position: relative;
  background-size: contain;
  cursor: pointer;
  background-color: ${COLORS.primaryLight};

  @media (max-width: 400px) {
    width: 163px;
    height: 90px;
  }
`

export const RecentlyUsedImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: ${RADII.item};
  object-fit: contain;
`
